import { useState } from 'react';
import { PrimaryButton } from '../atoms';
import { EditCourseModal } from './EditCourseModal';
import { handleClose, handleOpen } from '../../common';
import type { TCourse } from '../../common/types/Course';

type TEditCourse = {
  courseDetails: TCourse;
  setTriggerUpdate: () => void;
};

const EditCourse = ({ courseDetails, setTriggerUpdate }: TEditCourse) => {
  const [courseModalOpen, setCourseModalOpen] = useState(false);
  const [updateSuccessful, setUpdateSuccessful] = useState(false);
  // const [triggerUpdate, setTriggerUpdate] = useState(false);

  const refreshPage = () => {
    if (updateSuccessful) {
      setTriggerUpdate();
    }

    handleClose(setCourseModalOpen);
  };

  return (
    <>
      <PrimaryButton
        type="button"
        onClick={() => handleOpen(setCourseModalOpen)}
      >
        Edit Course <span className="material-symbols-rounded">edit</span>
      </PrimaryButton>
      <EditCourseModal
        isModalOpen={courseModalOpen}
        handleModalClose={refreshPage}
        courseDetails={courseDetails}
        setUpdateSuccessful={setUpdateSuccessful}
      />
    </>
  );
};

export { EditCourse };
